import * as React from "react";
import { Field } from "formik";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
const toFormStateValue = (newMinute) => {
  let minute = String(newMinute).slice(-2);
  if (String(minute).length === 1) {
    minute = `0${minute}`;
  }
  return `00:${minute}`;
};
export const fromFormStateValue = (timeString) => {
  var _a;
  return (_a = timeString == null ? void 0 : timeString.slice(-2)) != null ? _a : "";
};
const onTimeChange = (onChange, name) => ({ target: { value: newValue } }) => {
  onChange({ target: { value: toFormStateValue(newValue), name } });
};
const MinuteOfHourInput = ({ id, required = false, min = 0, max = 59 }) => {
  const { t } = useTranslation("enterprise_report");
  return /* @__PURE__ */ React.createElement(Field, { name: id }, ({ field: { name, value, onChange, onBlur }, meta: { error, touched } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      id: name,
      name,
      onBlur,
      error: error && touched ? error : void 0,
      type: "number",
      placeholder: t("minute_of_hour.placeholder"),
      formGroupClassName: "no-bm",
      inputDescClassName: "no-bm",
      onChange: onTimeChange(onChange, name),
      min,
      max,
      required,
      value: fromFormStateValue(value)
    }
  ));
};
export default MinuteOfHourInput;
